/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1ExamQuestionLibraryItemExamitemidQueryResponse,
  GetApiV1ExamQuestionLibraryItemExamitemidPathParams,
  GetApiV1ExamQuestionLibraryItemExamitemid401,
  GetApiV1ExamQuestionLibraryItemExamitemid404,
  GetApiV1ExamQuestionLibraryItemExamitemid500,
} from "../../types/examQuestionLibraryController/GetApiV1ExamQuestionLibraryItemExamitemid.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1ExamQuestionLibraryItemExamitemid } from "../../clients/examQuestionLibraryController/getApiV1ExamQuestionLibraryItemExamitemid.ts";

export const getApiV1ExamQuestionLibraryItemExamitemidQueryKey = (
  examItemId: GetApiV1ExamQuestionLibraryItemExamitemidPathParams["examItemId"],
) =>
  [
    {
      url: "/api/v1/exam/question-library/item/:examItemId",
      params: { examItemId: examItemId },
    },
  ] as const;

export type GetApiV1ExamQuestionLibraryItemExamitemidQueryKey = ReturnType<
  typeof getApiV1ExamQuestionLibraryItemExamitemidQueryKey
>;

export function getApiV1ExamQuestionLibraryItemExamitemidQueryOptions(
  examItemId: GetApiV1ExamQuestionLibraryItemExamitemidPathParams["examItemId"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey =
    getApiV1ExamQuestionLibraryItemExamitemidQueryKey(examItemId);
  return queryOptions<
    GetApiV1ExamQuestionLibraryItemExamitemidQueryResponse,
    ResponseErrorConfig<
      | GetApiV1ExamQuestionLibraryItemExamitemid401
      | GetApiV1ExamQuestionLibraryItemExamitemid404
      | GetApiV1ExamQuestionLibraryItemExamitemid500
    >,
    GetApiV1ExamQuestionLibraryItemExamitemidQueryResponse,
    typeof queryKey
  >({
    enabled: !!examItemId,
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1ExamQuestionLibraryItemExamitemid(examItemId, {
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description Retorna todas as informações de uma questão da biblioteca pelo seu identificador, incluindo tipo de componente, enunciado, configurações, idioma, status e, quando aplicável, as opções da lista de respostas. **(Requer Authorization para autenticação)**
 * @summary Obter detalhes completos de uma questão (Requer Authorization para autenticação)
 * {@link /api/v1/exam/question-library/item/:examItemId}
 */
export function useGetApiV1ExamQuestionLibraryItemExamitemid<
  TData = GetApiV1ExamQuestionLibraryItemExamitemidQueryResponse,
  TQueryData = GetApiV1ExamQuestionLibraryItemExamitemidQueryResponse,
  TQueryKey extends QueryKey =
    GetApiV1ExamQuestionLibraryItemExamitemidQueryKey,
>(
  examItemId: GetApiV1ExamQuestionLibraryItemExamitemidPathParams["examItemId"],
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1ExamQuestionLibraryItemExamitemidQueryResponse,
        ResponseErrorConfig<
          | GetApiV1ExamQuestionLibraryItemExamitemid401
          | GetApiV1ExamQuestionLibraryItemExamitemid404
          | GetApiV1ExamQuestionLibraryItemExamitemid500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ??
    getApiV1ExamQuestionLibraryItemExamitemidQueryKey(examItemId);

  const query = useQuery(
    {
      ...getApiV1ExamQuestionLibraryItemExamitemidQueryOptions(
        examItemId,
        config,
      ),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiV1ExamQuestionLibraryItemExamitemid401
      | GetApiV1ExamQuestionLibraryItemExamitemid404
      | GetApiV1ExamQuestionLibraryItemExamitemid500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
